import { Component } from '@angular/core';

@Component({
  selector: 'uni-nav-header',
  templateUrl: './uni-nav-header.component.html',
  styleUrls: ['./uni-nav-header.component.scss']
})
export class UniNavHeaderComponent {}
